"use strict";
/* LunaError from https://wiki.unitedtraders.team/pages/viewpage.action?pageId=41320585 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restErrorsToForm = void 0;
/**
 * Converts error from backend to form errors
 * @param error Error or LunaError
 * @param formErrorKey key for error that applies to the whole form (not a specific field)
 * @param fieldMapper mapper from `path` in backend response to `field` in form
 */
var restErrorsToForm = function (error, formErrorKey, fieldMapper) {
    var _a, _b, _c;
    var _d, _e;
    if (formErrorKey === void 0) { formErrorKey = 'FINAL_FORM/form-error'; }
    if (fieldMapper === void 0) { fieldMapper = function (path) { return path.split('.').pop(); }; }
    // not LunaError
    if (!('details' in error)) {
        return _a = {}, _a[formErrorKey] = { message: error.message, details: {} }, _a;
    }
    if ((_d = error.details) === null || _d === void 0 ? void 0 : _d.fields) {
        return error.details.fields.reduce(function (result, _a) {
            var _b;
            var path = _a.path, rest = __rest(_a, ["path"]);
            return (__assign(__assign({}, result), (_b = {}, _b[fieldMapper(path)] = rest, _b)));
        }, {});
    }
    if (error.details.message) {
        return _b = {},
            _b[formErrorKey] = {
                message: error.details.message,
                details: error.details.attributes || {}
            },
            _b;
    }
    return _c = {},
        _c[formErrorKey] = {
            message: error.type.replace(/\./g, '-'),
            details: ((_e = error.details) === null || _e === void 0 ? void 0 : _e.attributes) || {}
        },
        _c;
};
exports.restErrorsToForm = restErrorsToForm;
